export default __webpack_public_path__ + "static/casting-4dcb6218eda06884b0b8edd956e15de3.jpg";